module.exports = __webpack_public_path__ + "img/11-2.9342d9ae.png";